import { FC } from 'react'
import Image from 'next/image'

import {
  checkmarkIcon,
  coupleSecurityEllipse,
  decorativeCurves,
  currencyExchangeIcon,
} from '@ui/assets'

export const BankLevelSecurity: FC = () => {
  return (
    <section className="bg-[#daf1fa] py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-16 md:grid md:grid-cols-2 md:items-center">
          {/* Text content - LEFT side on desktop, BOTTOM on mobile */}
          <div className="order-2 max-w-[580px] md:order-1">
            <h2 className="font-display mb-10 text-4xl leading-none tracking-[-1.52px] text-[#0a2d4a] md:text-6xl lg:text-[56px]">
              Optimize
              <br />
              <span className="text-[#29bfed]">Your Finances</span>
            </h2>
            <p className="mb-10 max-w-[456px] text-[19px] leading-[1.4] text-[#0a2d4a]">
              Use ATM Personal Finance to track, manage, and grow your finances.
              Keep track of your spending, set custom alerts, and cancel
              subscriptions all from the comfort of your palms.
              <br />
              <br /> Spot cash short falls before they happen and protect
              yourself from overdraft fees by applying for cash advances or
              complete easy offers.
            </p>

            <div className="space-y-5">
              <div className="flex items-center gap-3 border-b border-[rgba(10,45,74,0.1)] pb-5">
                <Image src={checkmarkIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-[#0a2d4a]">
                  Track your spending and boost your savings
                </p>
              </div>

              <div className="flex items-center gap-3 border-b border-[rgba(10,45,74,0.1)] pb-5">
                <Image src={checkmarkIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-[#0a2d4a]">
                  Cancel unnecessary subscriptions
                </p>
              </div>

              <div className="flex items-center gap-3">
                <Image src={checkmarkIcon} width={24} height={22} alt="" />
                <p className="text-[18px] text-[#0a2d4a]">
                  Grow and protect your money through cash advances and earnings
                  opportunities
                </p>
              </div>
            </div>
          </div>

          {/* Security visuals - RIGHT side on desktop, TOP on mobile */}
          <div className="relative order-1 h-auto min-h-[400px] md:order-2 md:h-[550px]">
            {/* Circular couple photo with ellipse */}
            <div className="absolute left-1/2 top-1/2 h-[300px] w-[250px] -translate-x-1/2 -translate-y-1/2 md:left-auto md:right-0 md:top-1/2 md:h-[420px] md:w-[350px] md:-translate-y-1/2 md:translate-x-0">
              <div className="rotate-[30deg]">
                <Image
                  src={coupleSecurityEllipse}
                  width={350}
                  height={420}
                  alt=""
                />
              </div>
            </div>

            {/* 82% Approaching Budget card - top left */}
            <div className="absolute left-[10px] top-0 z-10 md:left-0 md:top-0">
              <div className="relative inline-flex w-[120px] flex-col items-center gap-3 rounded-[20px] bg-white p-4 shadow-[0px_4px_0px_0px_rgba(10,45,74,0.1)] md:w-[172px] md:gap-5 md:p-7">
                <div className="relative flex h-[90px] w-[90px] items-center justify-center md:h-[132px] md:w-[132px]">
                  {/* SVG Progress Circle */}
                  <svg
                    className="absolute inset-0 h-full w-full -rotate-90"
                    viewBox="0 0 132 132"
                  >
                    {/* Background circle */}
                    <circle
                      cx="66"
                      cy="66"
                      r="56"
                      fill="white"
                      stroke="#e5e7eb"
                      strokeWidth="10"
                    />
                    {/* Progress circle - 82% filled */}
                    <circle
                      cx="66"
                      cy="66"
                      r="56"
                      fill="none"
                      stroke="#29bfed"
                      strokeWidth="10"
                      strokeDasharray="351.86"
                      strokeDashoffset="63.33"
                      strokeLinecap="round"
                    />
                  </svg>
                  {/* Percentage text */}
                  <div className="relative z-10 text-center">
                    <span className="text-[30px] font-semibold leading-none tracking-[-1.35px] text-[#0a3754] md:text-[45px]">
                      82
                    </span>
                    <span className="text-[14px] font-semibold leading-none tracking-[-0.6px] text-[#0a3754] md:text-[20px]">
                      %
                    </span>
                  </div>
                </div>
                <p className="font-display text-center text-[11px] uppercase tracking-[-0.3px] text-[#0a3754] md:text-[15px]">
                  APPROACHING BUDGET
                </p>
                {/* Decorative curves overlay */}
                <div className="absolute left-[-20px] top-[-64px] hidden rotate-45 md:block">
                  <Image src={decorativeCurves} width={80} height={80} alt="" />
                </div>
              </div>
            </div>

            {/* Paycheck Received card - bottom right */}
            <div className="absolute bottom-16 right-[10px] z-10 flex items-center gap-2 rounded-[20px] bg-white px-3 py-2 shadow-[0px_4px_0px_0px_rgba(10,45,74,0.1)] md:hidden lg:right-[-56px] lg:flex lg:gap-4 lg:rounded-[27px] lg:px-6 lg:py-4">
              <div className="flex h-[40px] w-[40px] items-center justify-center rounded-[20px] bg-[#34af46]/15 p-2 lg:h-[54px] lg:w-[54px] lg:rounded-[27px] lg:p-3">
                <Image
                  src={currencyExchangeIcon}
                  width={31}
                  height={31}
                  alt=""
                  className="h-auto w-[20px] lg:w-[31px]"
                />
              </div>
              <p className="font-display text-[13px] tracking-[-0.36px] text-[#0a3754] lg:text-[18px]">
                Paycheck Received
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
